// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main_QwdFjz {\n  position: absolute;\n}\n.main_QwdFjz img {\n  width: 100%;\n  height: 100%;\n}\n.main_QwdFjz .cmp_YAuecH {\n  white-space: break-spaces;\n  overflow: hidden;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Cmp/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAFA;EAII,WAAA;EACA,YAAA;AACJ;AANA;EASI,yBAAA;EACA,gBAAA;AAAJ","sourcesContent":[".main {\n  position: absolute;\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n\n  .cmp {\n    white-space: break-spaces;\n    overflow: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "main_QwdFjz",
	"cmp": "cmp_YAuecH"
};
export default ___CSS_LOADER_EXPORT___;
